import React, { Component } from "react";
import DateRangePicker from "../../../date/daterangepicker.component.jsx";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import DebounceInput from "react-debounce-input";
import { injectIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
    "within": {
        id: "common.search_filter.operation.within",
        defaultMessage: "within the last",
    },
    "greaterThan": {
        id: "common.search_filter.operation.greaterThan",
        defaultMessage: "greater than",
    },
    "lowerThan": {
        id: "common.search_filter.operation.lowerThan",
        defaultMessage: "lower than",
    },
    "between": {
        id: "common.search_filter.operation.between",
        defaultMessage: "between",
    },
    "is": {
        id: "common.search_filter.operation.is",
        defaultMessage: 'is',
    },
    "months": {
        id: "common.search_filter.date_operation.months",
        defaultMessage: 'months',
    },
    "days": {
        id: "common.search_filter.date_operation.days",
        defaultMessage: 'days',
    },
    "and": {
        id: "common.search_filter.date_operation.and",
        defaultMessage: 'and',
    },
})

class DateFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            operation: props.op || "is",
            isComposite: (props.op === 'between'),
            calendarFocused: false,
            startDate: this.props.value !== undefined ? this.props.value.startDate : null,
            endDate: this.props.value !== undefined ? this.props.value.endDate : null,

        }

        this.onChangeSelectOp = this.onChangeSelectOp.bind(this);
        this.onChangeCompositeDate = this.onChangeCompositeDate.bind(this);
        this.onChangeSingle = this.onChangeSingle.bind(this)
        this.onChangeSelectDaysOrMonths = this.onChangeSelectDaysOrMonths.bind(this)
        this.onChangeWithinFilter = this.onChangeWithinFilter.bind(this)
        this.onFocusRangeDatePicker = this.onFocusRangeDatePicker.bind(this)
    }

    //Using startDate to indicate if days or months and end date for the number of days
    onChangeWithinFilter(event) {
        var numberPattern = /^[0-9]+$/
        var number = event.target.value;
        var label = (this.state.startDate === 'M') ? this.props.intl.formatMessage(messages["months"]) : this.props.intl.formatMessage(messages["days"])
        var isNumber = number.match(numberPattern)

        if (isNumber && number !== "") {
            this.setState({ startDate: this.state.startDate || "d", endDate: number })
            this.props.onChangeValues("add", this.props.id, { startDate: this.state.startDate || "d", endDate: number }, " " + number + " " + label, this.state.operation)
        } else {
            this.setState({ startDate: null, endDate: null })
            this.props.onChangeValues("remove", this.props.id, "")
        }
    }

    onChangeCompositeDate(startDate, endDate) {
        if (startDate !== null && endDate !== null && startDate != undefined && endDate != undefined) {
            this.setState({ startDate: startDate, endDate: endDate })
            this.props.onChangeValues("add", this.props.id, { startDate: startDate, endDate: endDate }, moment(startDate).format('MMMM Do YYYY') + " " + this.props.intl.formatMessage(messages["and"]) + " " + moment(endDate).format('MMMM Do YYYY'), 'between')

        } else {
            if (startDate !== null && startDate !== undefined) {
                this.setState({ startDate: startDate, endDate: null })
            } else {
                this.setState({ startDate: null, endDate: null })
            }
            this.props.onChangeValues("remove", this.props.id, "")
        }
    }

    onChangeSelectOp(event) {
        let aux = event.target.value.lastIndexOf("-") + 1
        let op = event.target.value.substring(aux, event.target.value.length)

        this.setState({ startDate: null, endDate: null, operation: op })
        this.props.onChangeValues("remove", this.props.id, "")
    }

    onChangeSingle(date) {
        if (date !== null) {
            this.setState({ startDate: date, endDate: null })
            this.props.onChangeValues("add", this.props.id, { startDate: date.toDate(), endDate: null }, moment(date.toDate()).format('MMMM Do YYYY'), this.state.operation)
        } else {
            this.setState({ startDate: date, endDate: null })
            this.props.onChangeValues("remove", this.props.id, "")
        }
    }

    onChangeSelectDaysOrMonths(event) {
        this.setState({ startDate: event.target.value, endDate: null })
        this.props.onChangeValues("remove", this.props.id, "")
    }

    onFocusRangeDatePicker() {
        this.props.manageScroll()
        this.props.onDateSelected()
    }

    getStartDate() {
        switch(this.state.startDate){
            case "now" :
                const nowDate = new Date()
                return moment(nowDate)
            case null :
                return null
            default :
                return moment(this.state.startDate)
        }
    }

    render() {
        return (
            <div className="panel panel-default card">
                <select
                    className="form-control mb-2"
                    name="operation-select"
                    value={this.props.id + "-" + this.state.operation}
                    onChange={this.onChangeSelectOp}
                    id={this.props.id + "-op"}
                >
                    <option value={this.props.id + "-is"}>{this.props.intl.formatMessage(messages["is"])}</option>
                    <option value={this.props.id + "-between"}>{this.props.intl.formatMessage(messages["between"])}</option>
                    <option value={this.props.id + "-greaterThan"}>{this.props.intl.formatMessage(messages["greaterThan"])}</option>
                    <option value={this.props.id + "-lowerThan"}>{this.props.intl.formatMessage(messages["lowerThan"])}</option>
                    <option value={this.props.id + "-within"}>{this.props.intl.formatMessage(messages["within"])}</option>
                </select>

                {
                    this.state.operation === 'between' ?
                        <DateRangePicker
                            startDate={this.state.startDate !== null ? moment(this.state.startDate) : null}
                            endDate={this.state.endDate !== null ? moment(this.state.endDate) : null}
                            onChange={this.onChangeCompositeDate}
                            onFocus={this.onFocusRangeDatePicker}
                            numberOfMonths={1}
                            id={this.props.id + "dateSelectorMultiple"}

                        />
                        : ((this.state.operation === 'within') ?
                            <div className='row'>
                                <div className='col-12 col-md-8'>
                                    <DebounceInput
                                        minLength={0}
                                        debounceTimeout={500}
                                        autoComplete="off"
                                        name="searchDate"
                                        value={this.state.endDate || ""}
                                        onChange={this.onChangeWithinFilter}
                                        id="searchDate"
                                        type="number"
                                        className="form-control"
                                    />
                                </div>
                                <div className='col-12 col-md-4'>
                                    <select
                                        className="form-control mb-2"
                                        name="operation-select"
                                        value={this.state.startDate || "d"}
                                        onChange={this.onChangeSelectDaysOrMonths}
                                        id={this.props.id + "-dateDays"}>
                                        <option value={"d"}>days</option>
                                        <option value={"M"}>months</option>
                                    </select>
                                </div>
                            </div>
                            :
                            <div className='datePicker'>
                                <SingleDatePicker
                                    small
                                    block
                                    displayFormat="LL"
                                    showClearDate={true}
                                    focused={this.state.calendarFocused}
                                    isOutsideRange={() => false}
                                    onDateChange={this.onChangeSingle}
                                    onFocusChange={() => {
                                        this.props.manageScroll()
                                        this.props.onDateSelected()
                                        this.setState({ calendarFocused: !this.state.calendarFocused })
                                    }}
                                    date={this.getStartDate()}
                                    numberOfMonths={1}
                                    id={this.props.id + "dateSelector"}
                                />
                            </div>
                        )

                }
            </div>

        );
    }
}
export default injectIntl(DateFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/dateFilter.component.jsx